"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var actions_1 = __importDefault(require("../../actions"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        createButton: {
            width: 150,
            height: 44,
            marginTop: theme.spacing(4),
        },
    });
});
function CreateButton(_a) {
    var className = _a.className;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    var openCreateUrlModal = function () { return dispatch(actions_1.default.openCreateUrlModal()); };
    return (react_1.default.createElement(core_1.Button, { size: "large", color: "primary", variant: "contained", onClick: openCreateUrlModal, className: classnames_1.default(className, classes.createButton) }, t('button.createLink')));
}
exports.default = CreateButton;
